import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import EditRoundedIcon from '@mui/icons-material/EditRounded'
import PauseCircleIcon from '@mui/icons-material/PauseCircle'
import { StatusChip as BadgeChip } from '../../../customComponents/StatusChip'

interface ChipSpec { label: string, icon?: JSX.Element, iconColor?: string }

// A complete building reads "Submitted" whether or not its report was submitted —
// report submission is a stamp, not a status. Edited is a provenance marker; Pending is
// "In progress"; a building with no form is "Not started".
const STATUS_CHIP: Record<string, ChipSpec> = {
  Submitted: { label: 'Submitted', icon: <CheckCircleIcon />, iconColor: 'var(--green-500)' },
  Edited: { label: 'Edited', icon: <EditRoundedIcon />, iconColor: 'var(--blue-300)' },
  Pending: { label: 'In progress', icon: <PauseCircleIcon />, iconColor: 'var(--orange-700)' },
  NotStarted: { label: 'Not started' }
}

export const StatusChip = ({ status }: { status: string }): JSX.Element => {
  const spec = STATUS_CHIP[status] ?? { label: status }
  return <BadgeChip label={spec.label} icon={spec.icon} iconColor={spec.iconColor} dataTestId='p2pStatusChip' />
}
